export default __webpack_public_path__ + "static/media/Forbidden Firestaff.7ea0979c.jpg";